import { createWebHistory, createRouter } from "vue-router";
import store from '../store/' 
import Home from "@/views/Home.vue";  
import Notification from "@/views/Notifications.vue"; 
import Districts from "@/views/page/Districts.vue"; 
import Role from "@/views/page/Role.vue";  
import ProductType from "@/views/page/ProductType.vue";  
import RolePermission from "@/views/page/RolePermission.vue";  
import User from "@/views/page/User.vue";  
import Customers from "@/views/page/Customers.vue";  
import Sales from "@/views/page/Sales.vue";  
import SaleAdd from "@/views/page/SaleAdd.vue";  
import Login from "@/views/page/Login.vue";   
import PermissionModule from "@/views/menu_and_permissions/ModuleOrMenu.vue";
import PermissionAction from "@/views/menu_and_permissions/PermissionAction.vue";

import ProductCategory from "@/views/page/ProductCategory.vue"; 
import Product from "@/views/product/Product.vue"; 
import AccountGroups from "@/views/account/Groups.vue"; 
import AccountAssigns from "@/views/account/Assigns.vue"; 
import Coupons from "@/views/page/Coupons.vue"; 
import ChatRoom from "@/views/page/ChatRoom.vue"; 
import SubscriptionRequest from "@/views/page/SubscriptionRequests.vue";  
import Conversations from "@/views/page/Conversations.vue"; 
import Sliders from "@/views/page/Sliders.vue"; 
import Profile from "@/views/page/Profile.vue";  
 
const route_list = store.getters.userRoutes;
var route_list_array = [];
for(let i=0; i<route_list.length; i++) {
  route_list_array.push({
    path: route_list[i].path,
    name: route_list[i].name,
    component: setComponent(route_list[i].component),
    icon_name: route_list[i].icon_name,
    meta: {
      module_name: route_list[i].module_name,
      parent_module: route_list[i].parent_module
    }
  });
}

function setComponent(component_name) { 
  return () => import(`@/views/${component_name}.vue`);
}
 
route_list_array.push( 
  {
    path: "/",
    name: "Dashboard",
    component: Home,
    icon_name: 'fas fa-th' 
  }, 
  {
    path: '/permissions/module-or-menu',
    name: 'Module/Menu',
    component: PermissionModule,
    icon_name: 'fas fa-folder',
  },
  {
    path: '/permissions/actions',
    name: 'Actions',
    component: PermissionAction,
    icon_name: 'fas fa-folder',
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    icon_name: 'fas fa-folder',
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    icon_name: 'fas fa-folder',
  } 
)

const routes = route_list_array;
const navigations = store.getters.userNavigations;
const router = createRouter({
  history: createWebHistory(),
  routes, 
  navigations
});
 
// router.beforeEach((to, from, next) => {
//   if (to.name !== 'Login' && !store.getters.token) next({ name: 'Login' })
//   else next()
// }) 


router.beforeEach((to, from, next) => {
if (to.name !== 'Login' && to.name !== 'Login' && !store.getters.token) next({ name: 'Login' });
else next() }) 

export default router;